import React, {useState} from "react"
import {useAuth} from "../contexts/AuthContext"
import {useHistory} from "react-router-dom"
import {Box, Button, Card, CardContent, Link, TextField} from "@mui/material";
import Alert from '@mui/material/Alert';
import { Link as RouterLink } from 'react-router-dom';


export default function Signup() {
    const {signup} = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    async function handleSubmit(e) {
        e.preventDefault()
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        const verifyPassword = document.getElementById('verify').value;
        const name = document.getElementById('name').value;

        if (password !== verifyPassword) {
            return setError("Passwords do not match")
        }

        try {
            setError("")
            setLoading(true)
            await signup(email, password, name)
            history.push("/login")
        } catch (e){
            console.log(e)
            setError(e.message)
        }

        setLoading(false)
    }

    //Handles if the user hits the enter key while typing
    const handleEnter = (e) => {
        if (e.key === "Enter") {
            handleSubmit(e)
        }
    }

    return (
        <Box>
            <Card>
                <CardContent>
                    {/*<h2>Sign Up</h2>*/}
                    <Box justifyContent="center" display="flex">
                        {error && <Alert severity="error">{error}</Alert>}
                    </Box>

                    <Box m={2}>
                        <TextField id="email" variant="outlined" label="Email..." onKeyPress={handleEnter}/>
                    </Box>
                    <Box m={2}>
                        <TextField id="name" variant="outlined" label="Name..." onKeyPress={handleEnter}/>
                    </Box>
                    <Box m={2}>
                        <TextField id="password" variant="outlined" label="Password..." type="password"
                                   onKeyPress={handleEnter}/>
                    </Box>
                    <Box m={2}>
                        <TextField id="verify" variant="outlined" label="Verify Password..." type="password"
                                   onKeyPress={handleEnter}/>
                    </Box>
                    <Box>
                        <Button disabled={loading} onClick={handleSubmit} variant="contained" color="primary">
                            Sign Up
                        </Button>
                    </Box>
                    <Box m={2}>
                        <Link component={RouterLink} to="/login">Have an account?</Link>
                    </Box>
                </CardContent>
            </Card>

        </Box>
    )
}
